import { cleanObject } from '@shared/utils';
import getPieveRuntimeInstanceHeader from '@/lib/apps/getPieveRuntimeInstanceHeader.js';
import { post } from '@/redux/requests/api.js';
import normalizeRequestFailure from '@/redux/requests/lib/normalizeRequestFailure.js';
import toValidationFailure from '@/redux/requests/lib/toValidationFailure.js';

const upsertCompanyCredential = ({ appId, credentialId, secrets, meta, isDefault, isCompany, isGlobal, source, signal } = {}, callback) => {
  const normalizedAppId = String(appId || '').trim();
  const normalizedCredentialId = String(credentialId || '').trim();

  if (!normalizedAppId) {
    return toValidationFailure('appId is required');
  }

  return post('/v1/pieve/credentials/upsert', {
    action: 'UPSERT_CREDENTIAL',
    meta: {
      credentialId: normalizedCredentialId || undefined,
      appId: normalizedAppId,
      secretsOverlay: secrets && typeof secrets === 'object' ? secrets : null,
      metaOverlay: meta && typeof meta === 'object' ? meta : null
    },
    callback,
    data: cleanObject(
      {
        appId: normalizedAppId,
        credentialId: normalizedCredentialId || undefined,
        secrets: secrets && typeof secrets === 'object' ? secrets : undefined,
        meta: meta && typeof meta === 'object' ? meta : undefined,
        isDefault: typeof isDefault === 'boolean' ? isDefault : undefined,
        isCompany: typeof isCompany === 'boolean' ? isCompany : undefined,
        isGlobal: typeof isGlobal === 'boolean' ? isGlobal : undefined,
        source: String(source || '').trim() || undefined
      },
      { strict: true }
    ),
    headers: {
      'x-mindcloud-instance': getPieveRuntimeInstanceHeader()
    },
    loader: 'upsertCompanyCredential',
    signal,
    onResponse: (responseShape) => {
      return normalizeRequestFailure({
        responseShape,
        fallbackMessage: 'Failed to upsert credential'
      });
    }
  });
};

export default upsertCompanyCredential;
